export default {
  title: "Report paid invoices"
}
